import { Divider } from "@material-ui/core";
import { Button, IconButton, MenuItem, Select, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as _ser from "../../../_redux/_services/JobPostingSlice";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import GetJobId from "../../../_utilities/GetJobId";
import { GetTimeZone } from "../../../_utilities/GetTimeZone";
import { getUserDetails } from "../../../_utilities/getUserInfo";
import CkEditor from "../../../components/CkEditor/CkEditor";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import { AddNotesillus } from "../../../Icons/AddNotesillus";
import { DashboardPlusicon } from "../../../Icons/DashboardPlusicon";
import { Notescall } from "../../../Icons/Notescall";
import { Notesemail } from "../../../Icons/Notesemail";
import "./PostingsNotes.css";
import EditIcon from "@mui/icons-material/Edit";

const initalState = { data: null, message: "", isloader: true };

const PostingsNotes = () => {
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [isLoadDoc, setIsLoadDoc] = useState(false);
  const [user, setUser] = useState([]);
  const [noteState, setNoteState] = useState("");
  const [selectedNote, setSelectedNote] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [isValidUser, setIsValidUser] = useState(false);
  const [showNoData, setShowNoData] = useState(false);
  const dispatch = useDispatch();
  const getJobId = GetJobId();

  useEffect(() => {
    if (getJobId !== null) {
      Getdata();
    }
  }, [getJobId]);

  const userData = useSelector((state) => state.Getnotes.data);
  const userDataCode = useSelector((state) => state.Getnotes.code);
  const showLoader = useSelector((state) => state.Loader.value);

  useEffect(() => {
    if (userDataCode === 404) {
      setIsValidUser(true);
    }
  }, [userDataCode]);

  useEffect(() => {
    let timer;
    if (user.length === 0 && !showLoader) {
      timer = setTimeout(() => {
        setShowNoData(true);
      }, 1000);
    } else {
      setShowNoData(false);
    }
    return () => clearTimeout(timer);
  }, [user, showLoader]);

  const Getdata = async () => {
    const userInfo = await getUserDetails();
    setUserDetails(userInfo);
    dispatch(_ser.getnotesAsync(getJobId));
  };

  useEffect(() => {
    if (userData && userData?.length > 0) {
      setUser(userData);
      setIsLoadDoc(false);
    } else if (userData && userData?.length === 0) {
      setIsLoadDoc(false);
    }
  }, [userData]);

  const onReceivePropsHandler = (pannel, load) => {
    setIsRightSidePannel(pannel);
    setIsLoadDoc(load);
    if (load === true) {
      setTimeout(() => {
        Getdata();
      }, 1200);
    }
    var element = document.getElementsByTagName("body");
    element[0].style.overflow = "";
  };

  const notesHandler = (type, data) => {
    setIsRightSidePannel(true);
    setNoteState(type);
    setSelectedNote(type === "Create" ? null : data);
    var element = document.getElementsByTagName("body");
    element[0].style.overflow = "hidden";
  };

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  return (
    <>
      {!isValidUser && (
        <div
          className="addnotessection"
          style={{ display: "flex", gap: "10px", marginTop: "-75px" }}
          onClick={() => {
            notesHandler("Create", null);
          }}
        >
          <DashboardPlusicon width={35} height={36} />
          <h4 className="addnotetext"> Notes </h4>
        </div>
      )}
      <div>
        {!showLoader && user.length > 0 ? (
          <>
            {user.map((elem, i) => {
              return (
                <>
                  <div style={{ position: "relative" }}>
                    <div className="usericon">
                      {elem.noteType === "Call" ? (
                        // <img src={process.env.PUBLIC_URL + "/assests/img/Notescall.svg"} alt="" />
                        <Notescall
                          secondaryColor={storedTheme?.secondaryColor}
                          secondaryFontColor={storedTheme?.secondaryFontColor}
                          width={40}
                          height={40}
                        />
                      ) : (
                        // <img src={process.env.PUBLIC_URL + "/assests/img/Notesemail.svg"} alt="" />
                        <Notesemail
                          secondaryColor={storedTheme?.secondaryColor}
                          secondaryFontColor={storedTheme?.secondaryFontColor}
                          width={40}
                          height={40}
                        />
                      )}
                    </div>
                    <div className="jobnote" style={{ marginLeft: "80px" }}>
                      <b>{elem.firstName + " " + elem.lastName}</b>
                      <div
                        style={{ maxWidth: "calc(100% - 150px)" }}
                        dangerouslySetInnerHTML={{ __html: elem.notes }}
                      ></div>
                      <span className="createdDate">
                        {GetTimeZone(elem.createdAt)}
                      </span>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: "30px",
                        right: "20px",
                      }}
                    >
                      {elem.userId === userDetails.userId ? (
                        <IconButton
                          color="primary"
                          onClick={() => {
                            notesHandler("Update", elem);
                          }}
                          component="label"
                        >
                          <EditIcon
                            className="appediticon1"
                            sx={{ color: storedTheme?.secondaryColor }}
                          />
                        </IconButton>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <Divider className="secline" />
                </>
              );
            })}
          </>
        ) : (
          !showLoader &&
          user.length === 0 && (
            <h1
              style={{
                fontWeight: 300,
                lineHeight: 1.2,
                textAlign: "center",
                margin: "60px 0",
                fontSize: "3rem",
              }}
            >
              No notes found
            </h1>
          )
        )}
      </div>
      {/* popup */}
      <div className="contentSection">
        {isRightSidePannel ? (
          <RightSideBar
            componentData={
              <ComponentRenderData
                noteState={noteState}
                selectedNote={selectedNote}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={
              noteState === "Create" ? pannelAddNotesobj : pannelEditNotesobj
            }
            footerImg={
              noteState === "Create" ? <AddNotesillus /> : <AddNotesillus />
            }
            onReceiveProps={onReceivePropsHandler}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

const ComponentRenderData = (props) => {
  const dispatch = useDispatch();
  const [noteType, setnoteType] = useState("Call");
  const [textValue, setTextValue] = useState(" ");
  const [disableSubmitBtn, setDisableSubmitBtn] = React.useState(false);
  const getJobId = GetJobId();
  const [showEditor, setShowEditor] = useState(false);

  const code = useSelector((state) => state.AddNotes.data);
  const updateCode = useSelector((state) => state.EditNotes.data);

  useEffect(() => {
    if (props.selectedNote !== null && props.noteState !== "Create") {
      setnoteType(props.selectedNote.noteType);
      setTextValue(props.selectedNote.notes);
      setShowEditor(true);
    } else {
      setnoteType("Call");
      setTextValue(" ");
      setShowEditor(true);
    }
  }, [props.noteState]);

  useEffect(() => {
    console.log("textValue +++", textValue);
  }, [textValue]);

  const HandleSubmit = async (event) => {
    event.preventDefault();
    if (textValue.trim().length > 0 && textValue !== " ") {
      setDisableSubmitBtn(true);
      const userInfo = await getUserDetails();
      let obj = {
        notes: textValue,
        noteType: noteType,
        moduleType: "jobopening",
        moduleId: getJobId,
        userId: userInfo.userId,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
      };
      if (props.noteState === "Create") {
        dispatch(_ser.addNotesAsync(obj))
          .then(() => {
            setDisableSubmitBtn(false);
          })
          .catch(() => {
            setDisableSubmitBtn(false);
          });
      } else {
        obj["id"] = props.selectedNote.id;
        dispatch(_ser.editNotesAsync(obj))
          .then(() => {
            setDisableSubmitBtn(false);
          })
          .catch(() => {
            setDisableSubmitBtn(false);
          });
      }
    } else {
      dispatch(updateSnackbar({ type: "error", message: "Please add notes" }));
    }
  };

  useEffect(() => {
    if (code === 200) {
      setTextValue("");
      handleReset();
      dispatch(_ser.addNotesStartReducer(initalState));
      props.onReceivechildProps(false, true);
    }
  }, [code]);

  useEffect(() => {
    if (updateCode === 200) {
      setTextValue("");
      handleReset();
      dispatch(_ser.editNotesStartReducer(initalState));
      props.onReceivechildProps(false, true);
    }
  }, [updateCode]);

  const handleChange = (value, type) => {
    setTextValue(value.data);
  };

  const handleChange1 = (event) => {
    setnoteType(event.target.value);
  };

  const formRef = useRef(null);

  const handleReset = () => {
    formRef.current.reset();
    setnoteType("Call");
    setTextValue("");
    props.onReceivechildProps(false, false);
  };

  return (
    <>
      <form ref={formRef}>
        <div className="type">
          Note Type
          <Select
            className="typeselectbutton"
            value={noteType}
            autoComplete="off"
            onChange={handleChange1}
          >
            <MenuItem value={"Call"}>Call</MenuItem>
            <MenuItem value={"E-mail"}>E-mail</MenuItem>
          </Select>
        </div>

        <div>
          <div id="jobDescForSMnew">
            {showEditor === true && (
              <CkEditor
                data={textValue}
                initRawData={textValue}
                autoComplete="off"
                name="note"
                isReadonly={false}
                onUpdatehandler={(update) => handleChange(update, "note")}
              />
            )}
          </div>
        </div>

        <div className="cancelsavebutton" style={{ marginTop: "28px" }}>
          <Stack spacing={2} direction="row">
            <Button
              className="notecancelbtn"
              variant="text"
              sx={{ color: "#FF0000" }}
              type="reset"
              onClick={handleReset}
            >
              <Link href="#" underline="always">
                {" "}
                Cancel
              </Link>
            </Button>
            <Button
              className="savebtn"
              variant="contained"
              size="small"
              type="submit"
              // disabled={textValue.trim().length === 0 || disableSubmitBtn}
              onClick={HandleSubmit}
              style={{ marginLeft: "0px" }}
            >
              {props.noteState === "Create" ? "Save" : "Update"}
            </Button>
          </Stack>
        </div>
      </form>
    </>
  );
};

export default PostingsNotes;

const pannelAddNotesobj = {
  title: "Add Notes",
  description: "",
  bgImage: "",
};

const pannelEditNotesobj = {
  title: "Edit Notes",
  description: "",
  bgImage: "",
};
